import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PatientOrderComponent } from './patient-order.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [PatientOrderComponent],
  exports: [PatientOrderComponent]
})
export class PatientOrderModule { }
